'use client'

import { XMarkIcon } from '@heroicons/react/24/outline'
import { useEffect, useRef, useState } from 'react'

const STORAGE_KEY = 'gwt-demo-banner-dismissed'

type Props = {
  message: string
  dismissLabel: string
}

export function DemoBanner({ message, dismissLabel }: Props) {
  const barRef = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY) === '1'
    setVisible(!dismissed)
  }, [])

  useEffect(() => {
    const root = document.documentElement

    function syncHeight() {
      const height = visible && barRef.current ? `${barRef.current.offsetHeight}px` : '0px'
      root.style.setProperty('--demo-banner-height', height)
    }

    syncHeight()
    window.addEventListener('resize', syncHeight)
    return () => {
      window.removeEventListener('resize', syncHeight)
      root.style.removeProperty('--demo-banner-height')
    }
  }, [visible])

  function dismiss() {
    localStorage.setItem(STORAGE_KEY, '1')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div data-component-id="src/components/layout/DemoBanner.tsx:46:4" data-component-path="src/components/layout/DemoBanner.tsx" data-component-line="46" data-component-end-line="60" data-component-file="DemoBanner.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-x-0%20top-0%20z-%5B100%5D%20flex%20w-full%20items-center%20justify-center%20gap-3%20border-b%20border-amber-600%2F20%20bg-amber-400%20px-4%20py-2.5%20text-center%20text-sm%20font-medium%20text-amber-950%20shadow-sm%22%7D"
      ref={barRef}
      role="status"
      className="fixed inset-x-0 top-0 z-[100] flex w-full items-center justify-center gap-3 border-b border-amber-600/20 bg-amber-400 px-4 py-2.5 text-center text-sm font-medium text-amber-950 shadow-sm"
    >
      <p data-component-id="src/components/layout/DemoBanner.tsx:51:6" data-component-path="src/components/layout/DemoBanner.tsx" data-component-line="51" data-component-end-line="51" data-component-file="DemoBanner.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22min-w-0%20flex-1%20leading-snug%20sm%3Aflex-none%22%7D" className="min-w-0 flex-1 leading-snug sm:flex-none">{message}</p>
      <button data-component-id="src/components/layout/DemoBanner.tsx:52:6" data-component-path="src/components/layout/DemoBanner.tsx" data-component-line="52" data-component-end-line="59" data-component-file="DemoBanner.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22shrink-0%20rounded-lg%20p-1%20text-amber-950%2F80%20transition%20hover%3Abg-amber-500%2F40%20hover%3Atext-amber-950%20focus-visible%3Aoutline-none%20focus-visible%3Aring-2%20focus-visible%3Aring-amber-900%2F30%22%7D"
        type="button"
        onClick={dismiss}
        aria-label={dismissLabel}
        className="shrink-0 rounded-lg p-1 text-amber-950/80 transition hover:bg-amber-500/40 hover:text-amber-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-900/30"
      >
        <XMarkIcon data-component-id="src/components/layout/DemoBanner.tsx:58:8" data-component-path="src/components/layout/DemoBanner.tsx" data-component-line="58" data-component-end-line="58" data-component-file="DemoBanner.tsx" data-component-name="XMarkIcon" data-component-content="%7B%22elementName%22%3A%22XMarkIcon%22%2C%22className%22%3A%22h-5%20w-5%22%7D" className="h-5 w-5" strokeWidth={2} aria-hidden />
      </button>
    </div>
  )
}
